<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane v-if="visibleCargo" key="1">
      <span slot="tab">
        <a-icon type="arrow-up"/>
        Cargo
      </span>
        <a-card>
          <employee-cargo :empleadoseleccionado="empleadoseleccionado"/>
        </a-card>
      </a-tab-pane>
      <a-tab-pane v-if="visibleOficina" key="2">
      <span slot="tab">
        <a-icon type="contacts"/>
        Oficina
      </span>
        <a-card>
          <employee-oficina :empleadoseleccionado="empleadoseleccionado"/>
        </a-card>
      </a-tab-pane>
      <a-tab-pane v-if="visibleTipoNomina" key="3">
      <span slot="tab">
        <a-icon type="dollar"/>
        Tipo de nómina
      </span>
        <a-card>
          <employee-tipo-pago :empleadoseleccionado="empleadoseleccionado"/>
        </a-card>
      </a-tab-pane>
      <a-tab-pane v-if="visibleHistDatosLaborales" key="4">
      <span slot="tab">
        <a-icon type="clock-circle"/>
        Histórico datos laborales
      </span>
        <a-card>
          <employee-att-hist :empleadoseleccionado="empleadoseleccionado"/>
        </a-card>
      </a-tab-pane>
      <a-tab-pane v-if="visibleReenganche && !$userIsInrol('Query')" key="5">
      <span slot="tab">
        <a-icon type="reload"/>
        Reenganche
      </span>
        <a-card>
          <employee-reenganche @loadData="loadData()" :empleadoseleccionado="empleadoseleccionado"/>
        </a-card>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    props: ['empleadoseleccionado'],
    methods: {
      loadData () {
        this.$emit('loadData')
      }
    },
    computed: {
      visibleCargo () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_CARGO')
        }
      },
      visibleOficina () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_OFICINA')
        }
      },
      visibleTipoNomina () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_TIPO_NOMINA')
        }
      },
      visibleHistDatosLaborales () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_HIST_DATOS_LABORALES')
        }
      },
      visibleReenganche () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_REENGANCHE')
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeInfoLabTabs.vue